import { useState, useEffect } from 'react'
import TreeService from '../services/tree.service'
import KpiService from '../services/kpi.service'
import { processKpis, deepMerge } from '../utils/kpiUtils'

const Arboreal = require('../../node_modules/arboreal/lib/arboreal')

/**
 * Hook personnalisé pour gérer les données KPI et la logique de traitement
 */
export const useKpiData = (kpiCode) => {
  const [bodyPage, setBodyPage] = useState('')
  const [bodyHtml, setBodyHtml] = useState('')
  const [dataSearch, setDataSearch] = useState(null)
  const [projectCodes, setProjectCodes] = useState(null)
  const [kpiDocument, setKpiDocument] = useState({})
  const [isLoaded, setIsLoaded] = useState(false)

  // Récupération de l'arbre et du document
  useEffect(() => {
    setIsLoaded(false)
    setProjectCodes(null)

    // Guard : pas d'appel API tant qu'on n'a pas d'ID valide
    // (au premier mount, Work.jsx passe kpiCode=0)
    if (!kpiCode || kpiCode === 0 || kpiCode === '0') {
      return
    }

    TreeService.getTree(kpiCode)
      .then(function (res) {
        const result = {}
        var pCodes = []
        
        result.page = new DOMParser().parseFromString(
          res.data.body.view.value.replace(/\s+/g, ' ').trim(),
          'text/html',
        ).childNodes[0].innerHTML
        
        result.html = new DOMParser().parseFromString(
          res.data.body.view.value.replace(/\s+/g, ' ').trim(),
          'text/html',
        )

        // Récupère les derniers niveaux de l'arbre
        function iterator(node) {
          if (
            node.children.length == 0 &&
            typeof node.data.title == 'string' &&
            pCodes.indexOf(node.data.id) == -1
          ) {
            pCodes.push(node.data.id)
          }
        }
        
        var tree = Arboreal.parse(res.data, 'childrens')
        tree.traverseDown(iterator)
        
        if (pCodes.length == 0) {
          pCodes.push(kpiCode)
        }

        // Traitement des images pour corriger les URLs
        result.html.querySelectorAll('img').forEach((img) => {
          const src = img.getAttribute('src')
          if (src) {
            const newSrc = "https://estoc-confluence.intradef.gouv.fr" + src
            img.setAttribute("src", newSrc)
          }
        })

        setBodyPage(result.page)
        setBodyHtml(result.html)
        setProjectCodes(pCodes)
        setDataSearch(result)
      })
      .catch((e) => {
        console.log(e)
      })
  }, [kpiCode])

  // Traitement des KPIs
  useEffect(() => {
    if (isLoaded == false && projectCodes && projectCodes.length > 0) {
      setIsLoaded(true)
      processKpis({ codes: {} }, projectCodes)
        .then((result) => {
          console.log(result)
          if (Object.keys(result.merge).length == 0) {
            setKpiDocument({ notexists: true })
          } else {
            if (
              projectCodes.length == 1 &&
              result.all.codes[projectCodes[0]].kpis
            ) {
              for (var kpi in result.all.codes[projectCodes[0]].kpis) {
                if (!result.merge[kpi]) {
                  result.merge[kpi] = {}
                }
                result.merge[kpi].report =
                  result.all.codes[projectCodes[0]].kpis[kpi].report
              }
            }
            setKpiDocument(result.merge)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    }
  }, [dataSearch, projectCodes])

  // Fonction pour mettre à jour un champ KPI
  const updateKpiField = (elem, type, prop) => {
    if (elem.target.name) {
      var keys = elem.target.name
      var tempObject = {}
      var container = tempObject
      
      keys.split('.').map((k, i, values) => {
        container = container[k] =
          i == values.length - 1 ? elem.target.value : {}
      })

      let merged = deepMerge(kpiDocument, tempObject)

      setKpiDocument({
        ...kpiDocument,
        [prop]: merged[prop],
      })
    }
  }

  // Fonction pour soumettre le formulaire modal
  const submitKpiForm = () => {
    KpiService.upsertKpi(kpiCode, kpiDocument)
      .then(() => {
        setDataSearch({
          ...dataSearch,
          codes: { [kpiCode]: { kpis: kpiDocument } },
        })
        
        processKpis(dataSearch, projectCodes)
          .then(() => {
            // Traitement des résultats si nécessaire
          })
          .catch((e) => {
            console.log(e)
          })
      })
      .catch((err) => console.log(err))
  }

  return {
    bodyPage,
    bodyHtml,
    dataSearch,
    projectCodes,
    kpiDocument,
    isLoaded,
    updateKpiField,
    submitKpiForm
  }
}
